/* FRIKY CLUB — panel visual de fidelización propio (sustituye al widget de Growave). Panel lateral
   con carné de socio (nivel + puntos + progreso), escalera de niveles, vitrina de logros y ganar/
   canjear. Lee /api/club-public/member-full. Sin dependencias. Marca Frikytopia (#f5bb2d/#1b2026). */
(function () {

  // Un vale se enseña solo si se puede usar: ni gastado ni caducado. Antes solo
  // se quitaban los gastados y un vale caducado seguía saliendo como «válido».
  function valeVivo(v) { return v && !v.used && (!v.caduca || new Date(v.caduca).getTime() > Date.now()); }
  // La compra mínima es la que calcula el servidor (la misma que tiene el código
  // en Shopify). Antes aquí se calculaba con un ×6 fijo y el cliente veía dos
  // mínimos distintos para el mismo vale (15-10-2026, caso Imanol: 175 € y 138,90 €).
  function condicionVale(v) {
    if (v.condicion) return v.condicion;
    var m = Number(v.minimo);
    return m > 0 ? 'Válido en compras desde ' + eur(m) : 'Sin compra mínima';
  }
  /* Traduce al idioma del mercado (friky-i18n.js). Si el diccionario aún no ha
     cargado, devuelve el texto tal cual: nunca rompe la interfaz. */
  function FTH(h) { return window.FTH ? window.FTH(h) : h; }
  function FT(t) { return window.FT ? window.FT(t) : t; }

  'use strict';
  if (window.__frikyClub) return; window.__frikyClub = 1;
  var API = 'https://frikyshop.fly.dev/api/club-public';
  var CID = (window.FRIKY_CUSTOMER_ID && String(window.FRIKY_CUSTOMER_ID).replace(/[^0-9]/g, '')) || '';

  /* ── DE DÓNDE VINO EL ALTA ──────────────────────────────────────────────────
     El pop-up añade ?fclub=<origen> al enlace de registro, pero entre ese clic y
     el momento en que la persona ya es cliente hay un viaje: formulario, correo
     de confirmación, a veces otra pestaña. Si el origen no se guarda, se pierde
     en el primer salto de página — que es justo lo que estaba pasando: la marca
     se ponía y no la recogía nadie.
     Aquí se guarda al llegar y se manda en cuanto hay cliente identificado. */
  (function () {
    var LLAVE = 'friky_club_origen';
    var VIDA = 30 * 864e5;                 // 30 días: de sobra para completar un alta
    var ORIGEN_API = 'https://frikyshop.fly.dev/api/visitas-public/alta-origen';

    function guardar(o) {
      try { localStorage.setItem(LLAVE, JSON.stringify({ o: o, at: Date.now() })); } catch (e) {}
    }
    function leer() {
      try {
        var r = JSON.parse(localStorage.getItem(LLAVE) || 'null');
        if (!r || !r.o) return null;
        if (Date.now() - r.at > VIDA) return null;   // caducado: mejor nada que un dato viejo
        return r;
      } catch (e) { return null; }
    }

    // 1. ¿Viene con marca en la URL? Se guarda y se limpia la barra de direcciones,
    //    para que el visitante no vea un parámetro raro ni lo comparta por ahí.
    try {
      var p = new URLSearchParams(location.search);
      var marca = p.get('fclub');
      if (marca) {
        guardar(marca);
        p.delete('fclub');
        var limpia = location.pathname + (p.toString() ? '?' + p.toString() : '') + location.hash;
        if (history.replaceState) history.replaceState(null, '', limpia);
      }
    } catch (e) {}

    // 2. ¿Ya es cliente? Entonces se reporta. El servidor comprueba por su cuenta
    //    que sea un alta RECIENTE y solo acepta orígenes de su lista, así que
    //    desde aquí no se puede ensuciar el informe.
    if (!CID) return;
    var hecho = 'friky_club_origen_enviado_' + CID;
    try { if (localStorage.getItem(hecho)) return; } catch (e) {}

    var r = leer();
    // Sin marca es «directo»: llegó al club sin pasar por ningún pop-up. Es un
    // dato tan útil como el resto — sin él no se sabe qué porcentaje trae cada
    // pieza, solo cuántos vinieron del pop-up sobre un total desconocido.
    var origen = r ? r.o : 'directo';

    fetch(ORIGEN_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cid: CID, origen: origen }),
      keepalive: true,
    }).then(function (res) { return res.json(); }).then(function (d) {
      // Se marca como enviado pase lo que pase con el resultado: si el servidor
      // dice que no es un alta reciente, insistir cada visita no lo va a cambiar.
      try {
        localStorage.setItem(hecho, '1');
        if (d && d.ok && r) localStorage.removeItem(LLAVE);
      } catch (e) {}
    }).catch(function () {});
  }());
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  var eur = function (n) { return (Number(n) || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };
  var intf = function (n) { return Math.round(Number(n) || 0).toLocaleString('es-ES'); };
  function fbCopy(text, cb){ try{ var ta=document.createElement('textarea'); ta.value=text; ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); }catch(e){} if(cb) cb(); }

  // Cómo ganar puntos: etiqueta + icono por acción (los pts vienen del backend).
  var EARN = {
    signup: ['🎉', FT('Únete al club')], birthday: ['🎂', FT('Tu cumpleaños')], referral: ['🤝', 'Trae a un amigo'],
    review: ['✍️', FT('Valora un producto')], review_photo: ['📸', FT('Reseña con foto/vídeo')], review_google: ['⭐', FT('Reseña en Google')],
    review_trustpilot: ['⭐', FT('Reseña en Trustpilot')], unboxing: ['🎥', 'Sube un unboxing'], wishlist: ['❤️', FT('Añade a favoritos')],
    collection: ['🖼️', FT('Sube tu colección')], follow_instagram: ['📷', FT('Síguenos en Instagram')], follow_tiktok: ['🎵', FT('Síguenos en TikTok')],
    follow_youtube: ['▶️', FT('Síguenos en YouTube')], follow_facebook: ['👍', FT('Síguenos en Facebook')], follow_x: ['✖️', FT('Síguenos en X')],
    share_social: ['🔗', FT('Comparte un producto')], newsletter: ['📩', FT('Suscríbete a la newsletter')],
  };

  var css =
    '.fclub-tab{position:fixed!important;top:38%!important;bottom:auto!important;right:0!important;left:auto!important;inset-inline-start:auto!important;inset-inline-end:0!important;writing-mode:horizontal-tb!important;text-transform:none!important;transform:rotate(-90deg)!important;transform-origin:bottom right!important;width:auto!important;height:auto!important;min-height:0!important;max-height:none!important;padding:0.55rem 1.5rem!important;margin:0!important;background:#f5bb2d!important;color:#1b2026!important;border:0!important;border-radius:0.8rem 0.8rem 0 0!important;font-size:1.5rem!important;font-weight:700!important;line-height:32px!important;letter-spacing:normal;cursor:pointer;z-index:2147482000!important;box-shadow:-4px 4px 18px rgba(0,0,0,.3);white-space:nowrap!important}' +
    '.fclub-tab:hover{filter:brightness(.97)}' +
    '.fclub-ov{position:fixed;inset:0;background:rgba(15,18,22,.45);z-index:2147482400;opacity:0;pointer-events:none;transition:opacity .2s}.fclub-ov.open{opacity:1;pointer-events:auto}' +
    '.fclub{position:fixed;top:0;right:0;height:100%;width:384px;max-width:100vw;background:#f4f6f8;z-index:2147482500;transform:translateX(100%);transition:transform .28s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column;font-family:inherit;box-shadow:-8px 0 30px rgba(0,0,0,.25)}' +
    '.fclub.open{transform:none}' +
    '.fclub__x{position:absolute;top:12px;right:12px;background:rgba(27,32,38,.15);border:0;color:#1b2026;width:30px;height:30px;border-radius:50%;font-size:16px;cursor:pointer;z-index:2}' +
    '.fclub__body{flex:1;overflow-y:auto}' +
    // Carné hero
    '.fclub-hero{color:#1b2026;padding:22px 18px 20px;position:relative}' +
    '.fclub-hero__lvl{font-size:34px;line-height:1}.fclub-hero__name{font-size:21px;font-weight:900;margin-top:2px}' +
    '.fclub-hero__pts{font-size:15px;opacity:.95;margin-top:2px}.fclub-hero__pts b{font-size:26px}' +
    '.fclub-hero__desc{font-size:12.5px;opacity:.92;margin-top:8px;line-height:1.4}' +
    '.fclub-bar{height:9px;background:rgba(27,32,38,.18);border-radius:999px;overflow:hidden;margin-top:12px}.fclub-bar>span{display:block;height:100%;background:#1b2026;border-radius:999px}' +
    '.fclub-bar__t{font-size:12px;margin-top:5px;opacity:.95}' +
    '.fclub-sec{background:#fff;margin:10px;border-radius:14px;padding:14px 15px;box-shadow:0 1px 3px rgba(0,0,0,.05)}' +
    '.fclub-sec__h{font-weight:800;font-size:14px;color:#1b2026;margin-bottom:10px;display:flex;align-items:center;justify-content:space-between}' +
    '.fclub-perk{display:flex;align-items:center;gap:8px;font-size:13px;color:#3a4250;padding:4px 0}.fclub-perk b{color:#16a34a}' +
    // Escalera de niveles
    '.fclub-lad{display:flex;flex-direction:column;gap:7px}' +
    '.fclub-lvl{display:flex;align-items:center;gap:10px;border:1.5px solid #eceef1;border-radius:11px;padding:9px 11px;cursor:pointer;transition:all .12s}' +
    '.fclub-lvl:hover{border-color:#f5bb2d}.fclub-lvl.cur{border-color:#1b2026;background:#fffdf3}' +
    '.fclub-lvl__e{font-size:22px;width:30px;text-align:center}.fclub-lvl__n{font-weight:700;font-size:13.5px;color:#1b2026;flex:1}' +
    '.fclub-lvl__b{font-size:11px;font-weight:800;color:#fff;background:#16a34a;border-radius:20px;padding:2px 8px}.fclub-lvl__b--you{background:#1b2026}.fclub-lvl__b--lock{background:#c3cad3}' +
    '.fclub-lvl__perks{font-size:12px;color:#5a6472;line-height:1.5;padding:2px 0 4px 40px;display:none}.fclub-lvl.exp .fclub-lvl__perks{display:block}' +
    // Logros
    '.fclub-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:9px}' +
    '.fclub-badge{text-align:center;cursor:default}.fclub-badge__ic{width:52px;height:52px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:24px;margin:0 auto;background:#fff3d6;box-shadow:0 2px 6px rgba(245,187,45,.35)}' +
    '.fclub-badge--lock .fclub-badge__ic{background:#eef0f2;filter:grayscale(1);opacity:.5}' +
    '.fclub-badge__l{font-size:10px;color:#3a4250;margin-top:4px;line-height:1.2;font-weight:600}.fclub-badge--lock .fclub-badge__l{color:#9aa4b2}' +
    // Ganar / canjear
    '.fclub-earn{display:flex;align-items:center;gap:9px;padding:6px 0;border-top:1px solid #f0f1f3;font-size:13px;color:#3a4250}.fclub-earn:first-child{border-top:0}.fclub-earn__e{font-size:17px;width:24px;text-align:center}.fclub-earn__n{flex:1}.fclub-earn__p{font-weight:800;color:#f5bb2d;background:#1b2026;border-radius:20px;padding:2px 9px;font-size:12px}' +
    '.fclub-cta{display:block;width:100%;background:#f5bb2d;color:#1b2026;border:0;border-radius:11px;padding:13px;font-weight:800;font-size:15px;cursor:pointer;margin-top:4px;text-align:center;text-decoration:none;box-sizing:border-box}.fclub-cta--dark{background:#1D1D1B!important;color:#F5BB2D!important;line-height:1!important;display:flex!important;align-items:center!important;justify-content:center!important;min-height:44px}.fclub-cta:hover{filter:brightness(.96)}' +
    '.fclub-cta--ghost{background:#fff;border:1.5px solid #1b2026}' +
    '.fclub-code{margin-top:10px;background:#0f1520;color:#f5bb2d;border-radius:10px;padding:11px;text-align:center;font-weight:800;letter-spacing:1px}' +
    '.fclub-vlist{margin-top:10px;display:flex;flex-direction:column;gap:8px}' +
    '.fclub-v{background:#0f1520;border-radius:10px;padding:10px 12px}' +
    '.fclub-v__t{font-size:12.5px;color:#cbd2da}.fclub-v__t b{color:#f5bb2d}' +
    '.fclub-v__row{display:flex;align-items:center;gap:8px;margin-top:6px}' +
    '.fclub-v__code{flex:1;min-width:0;font-weight:800;letter-spacing:1px;color:#f5bb2d;font-size:15px;font-family:monospace;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.fclub-v__copy{background:#f5bb2d;color:#1b2026;border:0;border-radius:8px;padding:8px 13px;font-weight:800;font-size:12px;cursor:pointer;white-space:nowrap}.fclub-v__copy:hover{filter:brightness(.96)}' +
    '.fclub-v__hint{font-size:10.5px;color:#7a8290;margin-top:5px}' +
    '.fclub-foot{text-align:center;font-size:10.5px;color:#9aa4b2;padding:8px 0 14px}' +
    '@media(max-width:749px){.fclub-tab{font-size:1.15rem!important;padding:0.45rem 1rem!important;top:42%!important}}@media(max-width:440px){.fclub{width:100vw}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // Lanzador (pestaña lateral) + panel
  var tab = document.createElement('button'); tab.className = 'fclub-tab'; tab.innerHTML = FTH('🏆 FRIKY CLUB');
  var ov = document.createElement('div'); ov.className = 'fclub-ov';
  var panel = document.createElement('div'); panel.className = 'fclub';
  panel.innerHTML = FTH('<button class="fclub__x" aria-label="Cerrar">✕</button><div class="fclub__body"><div style="padding:40px;text-align:center;color:#9aa4b2">Cargando tu club…</div></div>');
  document.body.appendChild(tab); document.body.appendChild(ov); document.body.appendChild(panel);
  var body = panel.querySelector('.fclub__body');

  function open() { ov.classList.add('open'); panel.classList.add('open'); if (!loaded) load(); }
  function close() { ov.classList.remove('open'); panel.classList.remove('open'); }
  tab.addEventListener('click', open); ov.addEventListener('click', close); panel.querySelector('.fclub__x').addEventListener('click', close);

  var loaded = false, data = null;
  function load() {
    if (!CID) { renderGuest(); loaded = true; return; }
    fetch(API + '/member-full?customerId=' + encodeURIComponent(CID)).then(function (r) { return r.json(); })
      .then(function (d) { data = d; loaded = true; render(); })
      .catch(function () { body.innerHTML = FTH(FT('<div style="padding:40px;text-align:center;color:#9aa4b2">No se pudo cargar el club. Reintenta.</div>')); });
  }

  function perksHtml(perks) { return (perks || []).map(function (p) { return '<div class="fclub-perk">✅ <span>' + esc(p) + '</span></div>'; }).join(''); }

  function render() {
    var t = data.tier || {}, next = data.nextTier;
    var grad = 'linear-gradient(135deg,#f5bb2d,#f2a71c)';
    var h = '';
    // Hero
    h += '<div class="fclub-hero" style="background:' + grad + '">' +
      '<div class="fclub-hero__lvl">' + esc(t.emoji || '🏆') + '</div>' +
      '<div class="fclub-hero__name">' + esc(t.label || '') + '</div>' +
      '<div class="fclub-hero__pts"><b>' + intf(data.points) + FT('</b> puntos · vale ') + eur(data.eurValue) + '</div>' +
      (t.desc ? '<div class="fclub-hero__desc">' + esc(t.desc) + '</div>' : '') +
      (next ? '<div class="fclub-bar"><span style="width:' + (data.progressToNextTier || 0) + '%"></span></div>' +
        FT('<div class="fclub-bar__t">Sigue sumando para llegar a ') + esc(next.emoji) + ' <b>' + esc(next.label) + '</b></div>'
        : FT('<div class="fclub-bar__t" style="margin-top:12px">🎉 ¡Estás en el nivel máximo!</div>')) +
      '</div>';
    // ── SUS VALES, NADA MÁS ABRIR ──
    // Estaban en «Canjea tus puntos», por debajo de ventajas, niveles y logros:
    // había que bajar media barra para ver el dinero que uno tiene. Aquí va un
    // botón que abre el mismo monedero del área de cliente. Solo si tiene algo.
    (function () {
      var vs = (data.vouchers || []).filter(valeVivo);
      if (!vs.length) return;
      var tot = vs.reduce(function (a, v) { return a + (Number(v.euro) || 0); }, 0);
      h += '<div class="fclub-sec"><button class="fclub-cta fclub-cta--dark" data-monedero style="width:100%">'
        + '👛 Ver mis vales · ' + eur(tot) + '</button></div>';
    })();

    // Canjear
    h += FT('<div class="fclub-sec"><div class="fclub-sec__h">💰 Canjea tus puntos</div>') +
      '<div class="fclub-perk">' + intf(data.redeem.points) + FT(' puntos = ') + eur(data.redeem.euro) + FT(' \u00b7 canjea el importe que quieras, sin m\u00ednimos</div>') +
      (function () {
        // EL ORDEN IMPORTA: primero lo que YA TIENE, después lo que le falta.
        //
        // Antes, a quien acababa de convertir sus puntos le salía «Aún no
        // tienes puntos que canjear» y punto. Leído del tirón parece que no
        // tiene nada, cuando en realidad acaba de generar un vale y lo tiene
        // justo debajo. Se dice primero que el vale está hecho y dónde verlo, y
        // solo después que no le quedan puntos hasta la próxima compra.
        if (data.canRedeem) {
          return '<button class="fclub-cta" data-redeem>Canjear ' + eur(data.eurValue) + ' en descuento</button>';
        }
        var libres = (data.vouchers || []).filter(valeVivo);
        if (libres.length) {
          var total = libres.reduce(function (a, v) { return a + (Number(v.euro) || 0); }, 0);
          return FT('<div class="fclub-bar__t" style="color:#7bd88f">✅ Ya tienes ' +
              (libres.length > 1 ? 'tus vales' : 'tu vale') + ' de ' + eur(total) + ' generado' +
              (libres.length > 1 ? 's' : '') + '</div>') +
            FT('<div class="fclub-bar__t" style="color:#9aa4b2">' +
              (libres.length > 1 ? 'Los tienes' : 'Lo tienes') +
              ' en «Mis vales» y aquí abajo, con su código listo para usar.</div>') +
            FT('<div class="fclub-bar__t" style="color:#9aa4b2;margin-top:6px">Puntos no te quedan: volverás a sumar con tu próxima compra.</div>');
        }
        return FT('<div class="fclub-bar__t" style="color:#9aa4b2">Aún no tienes puntos que canjear</div>');
      })() +
      (function(){ var items=[]; (data.coupons||[]).forEach(function(cp){ items.push({t:(cp.title||'Cupon del club'), val:(cp.kind==='envio'?'Gratis':cp.kind==='percent'?(cp.value+'%'):eur(cp.value)), code:cp.code, h:(cp.desc||'Cupon exclusivo del club'), ico:(cp.kind==='envio'?'\uD83D\uDE9A':null)}); }); (data.vouchers||[]).filter(valeVivo).forEach(function(v){ items.push({t:'Tu vale de descuento', val:eur(v.euro), code:v.code, h:condicionVale(v) + ' · aplícalo en el pago'}); }); return items.length ? ('<div class="fclub-vlist">' + items.map(function(x){ return '<div class="fclub-v"><div class="fclub-v__t">' + (x.ico || '\uD83C\uDF9F\uFE0F') + ' ' + esc(x.t) + ' <b>' + x.val + '</b></div><div class="fclub-v__row"><code class="fclub-v__code">' + esc(x.code) + '</code><button class="fclub-v__copy" data-copy="' + esc(x.code) + '">Copiar</button></div><div class="fclub-v__hint">' + esc(x.h) + '</div></div>'; }).join('') + '</div>') : ''; })() + '</div>';
    // Ganar puntos

    // Ventajas del nivel
    h += FT('<div class="fclub-sec"><div class="fclub-sec__h">🎖️ Tus ventajas</div>') + perksHtml(t.perks) + '</div>';
    // Escalera de niveles
    h += '<div class="fclub-sec"><div class="fclub-sec__h">🏆 Niveles del club</div><div class="fclub-lad">';
    (data.ladder || []).slice().reverse().forEach(function (l) {
      var badge = l.current ? FT('<span class="fclub-lvl__b fclub-lvl__b--you">TÚ</span>') : (l.reached ? '<span class="fclub-lvl__b">✓</span>' : '<span class="fclub-lvl__b fclub-lvl__b--lock">🔒</span>');
      h += '<div class="fclub-lvl' + (l.current ? ' cur' : '') + '" data-lvl>' +
        '<span class="fclub-lvl__e">' + esc(l.emoji) + '</span><span class="fclub-lvl__n">' + esc(l.label) + '</span>' + badge +
        '<div class="fclub-lvl__perks">' + (l.perks || []).map(function (p) { return '• ' + esc(p); }).join('<br>') + '</div></div>';
    });
    h += '</div></div>';
    // Logros
    h += FT('<div class="fclub-sec"><div class="fclub-sec__h"><span>🏅 Tus logros</span><span style="color:#f5bb2d">') + data.logrosUnlocked + '/' + data.logrosTotal + '</span></div><div class="fclub-grid">';
    (data.logros || []).forEach(function (g) {
      h += '<div class="fclub-badge' + (g.unlocked ? '' : ' fclub-badge--lock') + '" title="' + esc(g.desc) + (g.pts ? ' · +' + g.pts + ' pts' : '') + '">' +
        '<div class="fclub-badge__ic">' + (g.unlocked ? esc(g.emoji) : '🔒') + '</div><div class="fclub-badge__l">' + esc(g.label) + '</div></div>';
    });
    h += '</div></div>';
h += FT('<div class="fclub-sec"><div class="fclub-sec__h">🎁 Gana más puntos</div>');
    Object.keys(data.earnActions || {}).forEach(function (k) {
      if (!EARN[k]) return; var e = EARN[k];
      h += '<div class="fclub-earn"><span class="fclub-earn__e">' + e[0] + '</span><span class="fclub-earn__n">' + esc(e[1]) + '</span><span class="fclub-earn__p">+' + data.earnActions[k] + '</span></div>';
    });
    h += FT('</div><div class="fclub-foot">Club Frikytopia · tu pasión, recompensada</div>');
    body.innerHTML = FTH(h);
    // interacciones
    body.querySelectorAll('[data-lvl]').forEach(function (el) { el.addEventListener('click', function () { el.classList.toggle('exp'); }); });
    var rb = body.querySelector('[data-redeem]'); if (rb) rb.addEventListener('click', redeem);
    // El monedero es el MISMO que el del área de cliente (friky-club-saldo.js):
    // se le pide que lo abra en vez de dibujar aquí otra lista que mantener.
    var mb = body.querySelector('[data-monedero]');
    if (mb) mb.addEventListener('click', function () {
      if (window.FRIKY_MONEDERO) window.FRIKY_MONEDERO();
      else location.href = '/pages/friky-club';
    });
    body.querySelectorAll('[data-copy]').forEach(function (cb) { cb.addEventListener('click', function () { var code = cb.getAttribute('data-copy'); var orig = cb.textContent; var ok = function(){ cb.textContent = FT('\u00A1Copiado! \u2713'); setTimeout(function(){ cb.textContent = orig; }, 1600); }; if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(ok).catch(function(){ fbCopy(code, ok); }); } else fbCopy(code, ok); }); });
  }

  function redeem() {
    var btn = body.querySelector('[data-redeem]'); if (btn) { btn.disabled = true; btn.textContent = FT('Generando…'); }
    fetch(API + '/redeem', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customerId: CID, points: data.points })   /* TODO su saldo, no el tramo de 100 */ })
      .then(function (r) { return r.json(); }).then(function (r) {
        if (r.ok && r.code) { loaded = false; load(); }
        else { if (btn) { btn.disabled = false; btn.textContent = FT('Reintentar canje'); } }
      }).catch(function () { if (btn) { btn.disabled = false; btn.textContent = FT('Reintentar canje'); } });
  }

  function renderGuest() {
    body.innerHTML =
      FTH('<div class="fclub-hero" style="background:linear-gradient(135deg,#f5bb2d,#f2a71c)">' +
      '<div class="fclub-hero__lvl">🏆</div><div class="fclub-hero__name">Club Frikytopia</div>' +
      '<div class="fclub-hero__desc">Suma puntos con cada compra, sube de nivel y desbloquea ventajas y logros exclusivos. ¡Únete gratis!</div></div>' +
      FT('<div class="fclub-sec"><div class="fclub-sec__h">🏆 Los niveles</div><div class="fclub-lad">') +
      ['🏆 Leyenda', '🎖️ Veterano', '🤝 Aliado', '🪖 Recluta'].map(function (x) { return '<div class="fclub-lvl"><span class="fclub-lvl__e">' + x.split(' ')[0] + '</span><span class="fclub-lvl__n">' + x.split(' ')[1] + '</span></div>'; }).join('') +
      '</div></div>' +
      FT('<div class="fclub-sec"><a class="fclub-cta" href="/account/register">Únete al club (gratis)</a>') +
      '<a class="fclub-cta fclub-cta--ghost" href="/account/login" style="margin-top:8px">Ya soy socio · Iniciar sesión</a></div>' +
      FT('<div class="fclub-foot">Club Frikytopia · tu pasión, recompensada</div>'));
  }
})();


